"use strict";

var _regeneratorRuntime = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Errors_1 = require("./Errors");

var SearchOnlyDocuments_1 = require("./SearchOnlyDocuments");

var Documents = /*#__PURE__*/function (_SearchOnlyDocuments_) {
  _inherits(Documents, _SearchOnlyDocuments_);

  var _super = _createSuper(Documents);

  function Documents(collectionName, apiCall, configuration) {
    _classCallCheck(this, Documents);

    return _super.call(this, collectionName, apiCall, configuration);
  }

  _createClass(Documents, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(document) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (document) {
                  _context.next = 3;
                  break;
                }

                throw new Error('No document provided');

              case 3:
                return _context.abrupt("return", this.apiCall.post(this.endpointPath(), document, options));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "upsert",
    value: function () {
      var _upsert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(document) {
        var options,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (document) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('No document provided');

              case 3:
                return _context2.abrupt("return", this.apiCall.post(this.endpointPath(), document, Object.assign({}, options, {
                  action: 'upsert'
                })));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function upsert(_x2) {
        return _upsert.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(document) {
        var options,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

                if (document) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('No document provided');

              case 3:
                return _context3.abrupt("return", this.apiCall.post(this.endpointPath(), document, Object.assign({}, options, {
                  action: 'update'
                })));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var idOrQuery,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                idOrQuery = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};

                if (!(typeof idOrQuery === 'string')) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", this.apiCall.delete(this.endpointPath(idOrQuery), idOrQuery));

              case 5:
                return _context4.abrupt("return", this.apiCall.delete(this.endpointPath(), idOrQuery));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "createMany",
    value: function () {
      var _createMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(documents) {
        var options,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                this.configuration.logger.warn('createMany is deprecated and will be removed in a future version. Use import instead, which now takes both an array of documents or a JSONL string of documents');
                return _context5.abrupt("return", this.import(documents, options));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createMany(_x4) {
        return _createMany.apply(this, arguments);
      }

      return createMany;
    }()
  }, {
    key: "import",
    value: function () {
      var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(documents) {
        var options,
            documentsInJSONLFormat,
            resultsInJSONLFormat,
            resultsInJSONFormat,
            failedItems,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};

                if (!Array.isArray(documents)) {
                  _context6.next = 13;
                  break;
                }

                _context6.prev = 2;
                documentsInJSONLFormat = documents.map(function (document) {
                  return JSON.stringify(document);
                }).join('\n');
                _context6.next = 11;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](2);

                if (!(RangeError instanceof _context6.t0 && (_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.includes('Too many properties to enumerate')))) {
                  _context6.next = 10;
                  break;
                }

                throw new Error("".concat(_context6.t0, "\n          It looks like you have reached a Node.js limit that restricts the number of keys in an Object: https://stackoverflow.com/questions/9282869/are-there-limits-to-the-number-of-properties-in-a-javascript-object\n\n          Please try reducing the number of keys in your document, or using CURL to import your data.\n          "));

              case 10:
                throw new Error(_context6.t0);

              case 11:
                _context6.next = 14;
                break;

              case 13:
                documentsInJSONLFormat = documents;

              case 14:
                _context6.next = 16;
                return this.apiCall.performRequest('post', this.endpointPath('import'), {
                  queryParameters: options,
                  bodyParameters: documentsInJSONLFormat,
                  additionalHeaders: {
                    'Content-Type': 'text/plain'
                  }
                });

              case 16:
                resultsInJSONLFormat = _context6.sent;

                if (!Array.isArray(documents)) {
                  _context6.next = 27;
                  break;
                }

                resultsInJSONFormat = resultsInJSONLFormat.split('\n').map(function (r) {
                  return JSON.parse(r);
                });
                failedItems = resultsInJSONFormat.filter(function (r) {
                  return r.success === false;
                });

                if (!(failedItems.length > 0)) {
                  _context6.next = 24;
                  break;
                }

                throw new Errors_1.ImportError("".concat(resultsInJSONFormat.length - failedItems.length, " documents imported successfully, ").concat(failedItems.length, " documents failed during import. Use `error.importResults` from the raised exception to get a detailed error reason for each document."), resultsInJSONFormat);

              case 24:
                return _context6.abrupt("return", resultsInJSONFormat);

              case 25:
                _context6.next = 28;
                break;

              case 27:
                return _context6.abrupt("return", resultsInJSONLFormat);

              case 28:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 6]]);
      }));

      function _import(_x5) {
        return _import2.apply(this, arguments);
      }

      return _import;
    }()
    /**
     * Returns a JSONL string for all the documents in this collection
     */

  }, {
    key: "export",
    value: function () {
      var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var options,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
                return _context7.abrupt("return", this.apiCall.get(this.endpointPath('export'), options));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _export() {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
    /**
     * Returns a NodeJS readable stream of JSONL for all the documents in this collection.
     */

  }, {
    key: "exportStream",
    value: function () {
      var _exportStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var options,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                return _context8.abrupt("return", this.apiCall.get(this.endpointPath('export'), options, {
                  responseType: 'stream'
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function exportStream() {
        return _exportStream.apply(this, arguments);
      }

      return exportStream;
    }()
  }]);

  return Documents;
}(SearchOnlyDocuments_1.SearchOnlyDocuments);

exports.default = Documents;